export default __webpack_public_path__ + "static/media/Image1.c8a05258.png";